import { render, staticRenderFns } from "./expander.vue?vue&type=template&id=61c8a328&scoped=true&"
import script from "./expander.vue?vue&type=script&lang=js&"
export * from "./expander.vue?vue&type=script&lang=js&"
import style0 from "./expander.vue?vue&type=style&index=0&id=61c8a328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8a328",
  null
  
)

export default component.exports